import { useEffect, useRef, useState } from "react";
import { Target, AlertTriangle } from "lucide-react";

const SAMPLE_MASTERY = [["Fractions", 82], ["Linear Equations", 61], ["Mensuration", 40]];

export default function LandingMastery() {
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setVisible(true); }, { threshold: 0.3 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section className="py-10 sm:py-16 bg-slate-50/70 border-b border-slate-100" data-testid="landing-mastery-section" ref={ref}>
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-10 items-center">
        <div>
          <span className="inline-flex items-center gap-1.5 bg-emerald-50 text-emerald-700 border border-emerald-300/60 rounded-full px-3 py-1 text-xs font-bold" data-testid="mastery-first-badge">
            <Target size={12} /> Industry First · Adaptive CBSE Mastery Engine
          </span>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl mt-3">Finds the exact mistake, not just the wrong answer.</h2>
          <p className="text-muted-foreground mt-3">SmartGuru tracks every misconception — like adding denominators instead of numerators — and quietly builds a micro-lesson to fix it before the next test.</p>
          <div className="bg-card border border-destructive/30 rounded-2xl p-4 mt-6 flex items-start gap-3" data-testid="misconception-example-card">
            <AlertTriangle className="text-destructive shrink-0 mt-0.5" size={18} />
            <div>
              <p className="text-sm font-bold">Misconception detected</p>
              <p className="text-xs text-muted-foreground mt-0.5">Adding denominators instead of keeping them the same → auto-generated micro-lesson triggered.</p>
            </div>
          </div>
        </div>
        <div className="bg-card border border-border rounded-3xl p-6 shadow-lg" data-testid="mastery-gauge-card">
          <p className="text-[10px] font-bold uppercase tracking-widest text-muted-foreground mb-4">Sample Mastery Breakdown</p>
          {SAMPLE_MASTERY.map(([label, pct]) => (
            <div key={label} className="mb-4 last:mb-0">
              <div className="flex justify-between text-sm font-semibold mb-1">
                <span className="flex items-center gap-1.5"><Target size={13} className="text-primary" />{label}</span>
                <span>{pct}%</span>
              </div>
              <div className="h-2.5 bg-muted rounded-full overflow-hidden">
                <div className="h-full bg-gradient-to-r from-[#26C4D5] via-[#84D43E] to-[#F7933E] rounded-full transition-all duration-1000 ease-out" style={{ width: visible ? `${pct}%` : "0%" }} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
